module.exports = __webpack_public_path__ + "img/whatsapp-1.4f71abbd.svg";